import React from 'react';

const STATUS_RANKS = [
  'error',
  'success',
  'loading',
  'none',
];

export function StatusList(props) {
  let overall_status = 'none';

  const status_items = props.statuses.map((status, index) => {
    let status_type = status.type;
    if (status_type == undefined) {
      status_type = 'error';
    }
    if (STATUS_RANKS.indexOf(status_type) < STATUS_RANKS.indexOf(overall_status)) {
      overall_status = status_type;
    }
    return (
      <div key={index} className={status.type}>
        {status.message}
      </div>
    );
  });

  const class_names = ['status-list', overall_status];
  return (
    <div className={class_names.join(' ')}>
      {status_items}
    </div>
  );
}
